export default __webpack_public_path__ + "static/media/warning.9287f5ce.mp3";